export default function (
    id,
    tipo = 'r',
    relacaoEntidade = null,
    relacaoEntidadeId = null,
    pessoa = null,
    extraRelations = null,
    tags = null
) {
  let window = typeof id !== 'undefined' ? `conta.${id}.show` : 'conta.new'
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Nova Conta',
    move: false,
    backdrop: true,
    clickOutside: false,
    closeOnEsc: false,
    windowClass: 'erp-window-modern v2 no-border-radius',
    width: '1000',
    height: '820',
    props: {
      id: id,
      $router: this.$router,
      router: this.$router,
      tipo: tipo,
      entidade: relacaoEntidade,
      entidadeId: relacaoEntidadeId,
      extraRelations: extraRelations,
      pessoa: pessoa,
      tags: tags
    }
  }, () => import('../components/Conta'))
    .then((wid) => {
      this.$uloc.window.listen(wid, {
        updated: (wid, val) => {
          console.log('Update payment event')
          this.load && this.load()
          this.updateConta && this.updateConta(val)
        },
        created: (wid, val) => {
          console.log('Create payment event')
          this.load && this.load()
          this.updateConta && this.updateConta(val)
        }
      })
    }) // return wid
}
